import { Controller } from '@hotwired/stimulus';

import Chat from '@/modules/chat';

export default class extends Controller {
  connect() {
    new Chat().init();
  }
}
